<template>
<header class="site-nav" id="site-nav">
      <a class="brand" href="#home" data-route="home" aria-label="返回羚喵加速器首页"><img src="/assets/lingmiao-accelerator-logo.png" alt="羚喵加速器"><b>羚喵加速器</b></a>
      <nav class="nav-links">
        <a class="nav-link" href="#home" data-nav="home" data-route="home">首页</a>
        <a class="nav-link" href="#library" data-nav="library" data-route="library">游戏库</a>
        <a class="nav-link" href="#news" data-nav="news" data-route="news">游戏资讯</a>
        <a class="nav-link" href="#download" data-nav="download" data-route="download">下载中心</a>
        <a class="nav-link" href="#help" data-nav="help" data-route="help">帮助中心</a>
        <a class="nav-link" href="#about" data-nav="about" data-route="about">关于我们</a>
      </nav>
      <button class="nav-toggle" type="button" data-action="toggle-menu" aria-label="打开导航菜单" aria-expanded="false">☰</button>
      <div class="nav-actions">
        <a class="primary-btn" :href="androidRelease.url" data-download>下载 Android 版</a>
      </div>
    </header>
</template>

<script setup>
import androidRelease from "../android-release.json";
</script>
